import React from "react";
import useTranslator from "../hooks/useTranslator";
import { isDefaulter } from "../helper/common";
import "./DefaultStatus.css";

const DefaultStatus = ({ profile, show = true, className = "" }) => {
  const { _t } = useTranslator();

  if (!show) return null;

  const defaulter = isDefaulter(
    profile?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3
  );

  return (
    <span className={`default-status-wrapper ${className}`}>
      <span className="default-status-divider" aria-hidden="true">
        |
      </span>
      <span
        className="default-status-text"
        style={{ color: !defaulter ? "#82cf3f" : "#ff3c3c" }}
      >
        {!defaulter ? _t("defaultFree") : _t("defaulter")}
      </span>
    </span>
  );
};

export default DefaultStatus;
